export const useStructureHeight = (
	structureHeight: React.RefObject<HTMLElement>
): string | undefined => `${structureHeight.current?.offsetHeight}`
